<template>
  <section class="banner content-padd-s" :class="{ isMobile }">
    <div class="banner-content content-width">
      <div class="banner-text-block">
        <div class="banner-text">
          <h1 class="banner-h1">
            Prowadź książkę obiektu budowlanego elektronicznie
          </h1>
          <p class="banner-p pr-3">
            System c-KOB to oficjalna rządowa aplikacja do prowadzenia cyfrowej
            Książki Obiektu Budowlanego, zastępująca jej tradycyjną papierową
            wersję. Umożliwia właścicielom
            <span class="nobr">i zarządcom</span> nieruchomości gromadzenie oraz
            aktualizowanie wszystkich wymaganych informacji dotyczących danego
            budynku <span class="nobr">w jednym</span> bezpiecznym miejscu.
          </p>
        </div>
        <div>
          <v-btn
            v-if="!isLogin"
            depressed
            color="primaryBlue"
            rounded
            large
            dark
            title="Kliknij, aby zalogować się do Elektronicznego Dziennika Budowy"
            @click="login"
          >
            Zaloguj się
          </v-btn>
          <v-btn
            v-else
            depressed
            color="primaryBlue"
            rounded
            large
            dark
            title="Kliknij, aby przejść do aplikacji"
            to="/konto/dane-uzytkownika"
          >
            Przejdź do aplikacji
          </v-btn>

          <v-btn
            to="dowiedz-sie-wiecej"
            depressed
            color="primaryBlue"
            rounded
            large
            dark
            outlined
            title="Kliknij, aby przejść do strony dowiedz się więcej"
            class="ml-2 ml-md-3"
          >
            Dowiedz się więcej
          </v-btn>
        </div>
      </div>
      <div class="banner-img-block">
        <img
          class="banner-img block"
          alt="Banner EDB"
          src="/img/banner-img.svg"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LibHomeSectionBanner",
  props: {},
  data() {
    return {};
  },
  methods: {
    login() {
      let props = this.$router.resolve({
        name: "Account"
      });
      let path = window.location.origin.split(/[?#]/)[0];
      if (path.endsWith("/")) path = path.slice(0, -1);
      this.$store.dispatch("auth/login", { redirectUri: path + props.href });
    },
    openWcagDialog() {
      this.isOpenPopupWcag = true;
      this.drawer = false;
    }
  }
};
</script>

<style scoped lang="scss">
/* BANNER */
.banner {
  background: #f0f6ff;
}

.banner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.banner-text-block {
  flex: 1 0;
  position: relative;
}
.banner-img-block {
  flex: 1 0;
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 1.5rem;
}
.banner-img {
  max-width: 100%;
}

.banner-text {
  max-width: 700px;
  margin-bottom: 2.2rem;
}
.banner-h1 {
  color: var(--c-primary-purple);
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 700;
  line-height: 120%;
  margin-bottom: 1.7rem;
}
.banner-p {
  font-size: 1rem;
  font-weight: 500;
}

.isMobile {
  .banner-content {
    flex-direction: column;
  }
  .banner-text-block {
    order: 2;
  }
  .banner-img-block {
    order: 1;
  }
  .banner-h1 {
    margin-bottom: 1rem;
  }
  .banner-text {
    margin-bottom: 1.3rem;
  }
  // .banner-p {
  //   font-size: 14px;
  // }
}
</style>
